import { Plus } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

interface HouseholdCreateCardProps {
  showCreateForm: boolean
  newHouseholdName: string
  loading: boolean
  onNameChange: (value: string) => void
  onShowCreateForm: (show: boolean) => void
  onCreate: () => void
}

export function HouseholdCreateCard({
  showCreateForm,
  newHouseholdName,
  loading,
  onNameChange,
  onShowCreateForm,
  onCreate,
}: HouseholdCreateCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center">
          <Plus className="mr-2 h-5 w-5" />
          Nieuw Huishouden
        </CardTitle>
        <p className="text-sm text-gray-600">
          Maak een gedeeld huishouden om recepten te delen met familie of huisgenoten.
        </p>
      </CardHeader>
      {showCreateForm ? (
        <CardContent className="space-y-4">
          <Input
            placeholder="Huishouden naam (bijv. Familie Janssen)"
            value={newHouseholdName}
            onChange={(e) => onNameChange(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && onCreate()}
          />
          <div className="flex gap-2">
            <Button
              variant="outline"
              onClick={() => {
                onShowCreateForm(false)
                onNameChange('')
              }}
              className="flex-1"
            >
              Annuleren
            </Button>
            <Button onClick={onCreate} disabled={loading || !newHouseholdName.trim()} className="flex-1">
              {loading ? 'Maken...' : 'Huishouden Maken'}
            </Button>
          </div>
        </CardContent>
      ) : (
        <CardContent>
          <Button onClick={() => onShowCreateForm(true)} className="w-full">
            <Plus className="mr-2 h-4 w-4" />
            Nieuw Huishouden Maken
          </Button>
        </CardContent>
      )}
    </Card>
  )
}
